import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TrainingProgressService } from '../../services/training-progress.service';
import { ConfettiService } from '../../services/confetti.service';
import { SafeHtmlPipe } from '../../shared/pipes/safe-html.pipe';
import { Icons } from '../../shared/icons';
import { TranslatePipe } from '../../../filters/translate.pipe';
import Session from '../../../utils/session.service';

@Component({
  selector: 'app-certificate',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe, TranslatePipe],
  templateUrl: './certificate.component.html',
  styleUrls: ['../../training-styles.css'],
  encapsulation: ViewEncapsulation.None
})
export class CertificateComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private trainingProgressService = inject(TrainingProgressService);
  private confettiService = inject(ConfettiService);
  private session = inject(Session);

  readonly Icons = Icons;

  isUnlocked = false;
  learnerName = '';
  organizationName = '';
  completedDate = '';
  certificateId = '';
  averageScore = 0;
  completedCount = 0;
  totalModules = 0;
  programmeTitle = '';
  programme: any = { title: '' };
  selectedProgramVersionCode = '';

  ngOnInit(): void {
    this.selectedProgramVersionCode = this.activatedRoute.snapshot.queryParamMap.get('programVersionCode') || '';
    this.trainingProgressService.setProgramVersionCode(this.selectedProgramVersionCode);

    this.trainingProgressService.loadSummary().then(summary => {
      this.isUnlocked = !!summary?.certificateCode;
      this.totalModules = summary?.totalModules || 0;
      this.completedCount = summary?.completedModules || 0;
      this.learnerName = summary?.learnerName || '';
      this.organizationName = summary?.organisationName || '';
      this.programmeTitle = summary?.programVersionTitle || '';
      this.programme = { title: this.programmeTitle };
      this.averageScore = Math.round((summary?.averageBestScore || 0) * 100);
      this.certificateId = summary?.certificateCode || '';
      const locale = ((this.session.getSession() || {}).user?.deviceLanguage || 'en_GB').replace('_', '-');
      this.completedDate = new Date().toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
      if (this.isUnlocked) {
        setTimeout(() => this.confettiService.launch(), 500);
      }
    });
  }

  printCertificate(): void {
    window.print();
  }

  navigate(path: string): void {
    const parts = path.startsWith('/') ? path.split('/').filter(Boolean) : [path];
    const queryParams = this.selectedProgramVersionCode ? { programVersionCode: this.selectedProgramVersionCode } : undefined;
    this.router.navigate(['/my-training', ...parts], { queryParams });
  }
}
